'use strict';

// разбивает дату на год, месяц и день
export function parseDate(str)
{
    let dt = str.split('-');
    let res = { year:1, month: 1, day: 1};
    if(dt.length > 0) res ['year'] = parseInt(dt[0]);
    if(dt.length > 1) res ['month'] = parseInt(dt[1]);
    if(dt.length > 2) res ['day'] = parseInt(dt[2]);
    return res;
}

// возвращает возраст на текущую дату
export function getOld(born)
{    
    let now = new Date();
    let date_born = new Date(born);

    let year = now.getFullYear() - date_born.getFullYear();
    let month = now.getMonth() - date_born.getMonth();
    if(month < 0) { month = 12 + month; year --; }
   
    let y = " л.";
    if(parseInt(year.toString().substring(y.toString() - 1)) <= 4) y = " г.";

    return year + y + " " + month + " мес.";
}

export default parseDate;